import { useTranslation } from 'react-i18next';

export const CountryInputSkeleton = () => {
  const { t } = useTranslation();
  return (
    <div data-testid='dynamic-input-field'>
      <div className='flex flex-row items-center mb-2'>
        <label className='text-primary text-body-xs' htmlFor='billingCountry'>
          {t('companySettings:countryLabel')}
        </label>
      </div>
      <div className='w-full h-12 bg-tertiary rounded-sm animate-pulse' />
    </div>
  );
};
